import { useState, useEffect } from 'react'

/**
 * This pull request is intended to manipulate page change
 *
 * @param page
 * @param total
 * @param onPageChange
 * @return {{pageClick: (function(*=, *): (undefined)), jumpToPage: jumpToPage, currentPage: *}}
 */
export default function useChangePage(page, total, onPageChange) {
  const [currentPage, setPage] = useState(page)

  useEffect(() => {
    setPage(page)
  }, [page])

  useEffect(() => { if (currentPage > total) jumpToPage({ target: { value: 1 } }, 1) }, [total])

  const jumpToPage = (event, newPage) => {
    setPage(newPage)
    onPageChange(event, newPage)
  }

  const pageClick = (event, dir) => {
    const nextPage = currentPage + dir
    if (nextPage < 1 || nextPage > total) return
    jumpToPage(event, nextPage)
  }

  return { currentPage, jumpToPage, pageClick }
}
